import { types } from 'mobx-state-tree';

export const CaseInfoModel = types
  .model('CaseInfoModel', {
    caseName: types.maybe(types.string),
    location: types.maybe(types.string),
    ledningskollenId: types.maybe(types.string)
  })
  .actions(self => ({
    setValues(changedValues) {
      for (let key in changedValues) {
        self[key] = changedValues[key];
      }
    }
  }));
